<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />

          <div class="row mb-2">
            <div class="col-md-12">
              <div
                class="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"
              >
                <div class="dropdown me-2 bg-success">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i class="ti ti-package-export me-2"></i>Import/Export
                  </a>
                  <div class="dropdown-menu dropdown-menu-end">
                    <ul>
                      <li>
                        <a
                          href="#"
                          class="dropdown-item"
                          @click="downloadPhoneExcel()"
                        >
                          <i class="ti ti-download text-blue me-1"></i>Export
                          Phone
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <!-- Search -->
            <div class="card-header">
              <div v-if="loading" class="loader">Loading...</div>
              <div class="row align-items-center">
                <div class="col-md-3 mb-2">
                  <input
                    type="text"
                    v-model="filters.searchQuery"
                    class="form-control"
                    placeholder="Enter Organization Name"
                  />
                </div>
              </div>
            </div>
            <!-- /Search -->
            <div class="card-body">
              <!-- Countries List -->
              <div v-if="!isLoading" class="table-responsive custom-table">
                <a-table
                  class="table"
                  :columns="columns"
                  :data-source="filteredData"
                  :row-selection="rowSelection"
                  row-key="id"
                  table-layout="fixed"
                >
                  <template #bodyCell="{ column, record }">
                    <template
                      v-if="
                        column.key === 'initial_info' && record?.initial_info
                      "
                    >
                      <ul class="custom-text-truncation">
                        <li>
                          {{ record?.initial_info?.organization_name }}<br />
                          <strong>Phone:</strong>
                          {{ record?.initial_info?.phone }}<br />
                          <strong v-if="record?.initial_info?.address"
                            >Address:</strong
                          >
                          {{ record?.initial_info?.address }}<br />
                          <strong v-if="record?.initial_info?.industry"
                            >Industry Type:</strong
                          >
                          {{ record?.initial_info?.industry?.type }}<br />
                        </li>
                      </ul>
                    </template>
                    <!-- Render Concern Person Info -->
                    <template
                      v-else-if="
                        column.key === 'concern_person_info' &&
                        record?.concern_person?.concern_person_info
                      "
                    >
                      <ul class="custom-text-truncation">
                        <li
                          v-for="(info, index) in record.concern_person
                            .concern_person_info"
                          :key="index"
                        >
                          <strong>Name:</strong> {{ info.name }}<br />
                          <strong>Emails:</strong> {{ info.email.join(", ")
                          }}<br />
                          <strong v-if="info.phone">Phones:</strong>
                          {{ info.phone.join(", ") }}<br />
                          <strong v-if="info.gender">Gender:</strong>
                          {{ info.gender }}<br />
                        </li>
                      </ul>
                    </template>
                  </template>
                </a-table>
              </div>

              <!-- Loading indicator -->
              <div v-else>
                <p>Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <lead-delete-modal v-if="isShowModal" @refresh="refresh" />
</template>

<script>
import http from "@/utils/http";
import moment from "moment";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      title: "From Key Account",
      loading: false,
      data: [],
      permissions: [],

      employees: [],
      exhibitions: [],
      industryTypesArr: [],

      leadStages: [
        { label: "New", value: "new" },
        { label: "In Progress", value: "in_progress" },
        { label: "Closed", value: "closed" },
      ],
      leadPriorities: [
        { name: "Very Good" },
        { name: "Good" },
        { name: "Low" },
        { name: "Very Low" },
      ],
      filters: {
        employee_id: "",
        stage: "",
        priority: "",
        startDate: null,
        endDate: null,
        selectedIndustryType: "",
        exhibition: "",
        searchQuery: "",
      },

      isLoading: true,
      isEditMode: false,
      isShowModal: false,
      columns: [
        {
          title: "Initial Info",
          key: "initial_info",
        },
        {
          title: "Concern Person Info",
          key: "concern_person_info",
        },
      ],

      rowSelection: {
        onChange: () => {},
        onSelect: () => {},
        onSelectAll: () => {},
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo", "userPermissions"]),
    hasDeletePermission() {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];

      return permissions.includes("Leads Delete");
    },

    filteredData() {
      return this.data.filter((item) => {
        const matchesSearch = item?.initial_info?.organization_name
          ?.toLowerCase()
          .includes(this.filters.searchQuery.toLowerCase());

        const matchesIndustry = this.filters.selectedIndustryType
          ? item?.initial_info.industry?.type ===
            this.filters.selectedIndustryType
          : true;

        const matchesPriority = this.filters.priority
          ? item?.lead_priority === this.filters.priority
          : true;

        const matchesStage = this.filters?.stage
          ? item?.lead_stage === this.filters.stage
          : true;

        const matchesExhibitions = this.filters.exhibition
          ? item?.initial_info.exhibitions?.some(
              (exhibition) =>
                this.filters?.exhibition?.id == exhibition?.exhibition_id?.id
            )
          : true;

        const matchesEmp = this.filters.employee_id
          ? item?.initial_info?.exhibitions?.some(
              (exhibition) =>
                exhibition?.employee_id?.id == this.filters.employee_id?.id ||
                exhibition?.additionalEmployeeID?.id ==
                  this.filters.employee_id?.id
            )
          : true;

        const createdAt = item.created_at ? moment(item.created_at) : null;
        const startDate = this.filters.startDate
          ? moment(this.filters.startDate).startOf("day")
          : null;
        const endDate = this.filters.endDate
          ? moment(this.filters.endDate).endOf("day")
          : null;

        // Filter by date range
        const matchesDateRange =
          createdAt && startDate && endDate
            ? createdAt.isBetween(startDate, endDate, null, "[]") // [] includes start & end
            : true;

        return (
          matchesEmp &&
          matchesExhibitions &&
          matchesIndustry &&
          matchesExhibitions &&
          matchesDateRange &&
          matchesStage &&
          matchesPriority &&
          matchesSearch
        );
      });
    },
  },

  async mounted() {
    this.isLoading = true;
    this.getEmployees();
    this.getLeadStages();
    this.getIndustryTypes();
    this.getExhibitions();

    if (this.$refs.dateRangeInput) {
      const start = moment().subtract(6, "days");
      const end = moment();

      new DateRangePicker(
        this.$refs.dateRangeInput,
        {
          startDate: moment(),
          endDate: moment(),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [
              moment().subtract(1, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "All Time": [moment("1970-01-01"), moment()],
          },
        },
        this.booking_range
      );
    }
    try {
      await this.getCollections();
      await this.checkLeadsPermission();
    } catch (error) {
      console.error("Error during mounting:", error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    booking_range(start, end) {
      this.filters.startDate = start ? start.format("M/D/YYYY") : "";
      this.filters.endDate = end ? end.format("M/D/YYYY") : "";
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    },
    async filterLeads() {
      await this.getCollections();
    },
    async getCollections() {
      this.isLoading = true;
      try {
        const response = await http.get("key-account-list", {
          params: this.filters,
        });
        this.data = response.data.contents;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },
    refresh() {
      this.isShowModal = false;
      this.getCollections();
    },

    async downloadPhoneExcel() {
      try {
        const response = await http.post(
          "/download-all-phone",
          {
            data: this.filteredData,
          },
          {
            responseType: "blob",
            headers: {
              Accept: "application/octet-stream",
            },
          }
        );

        let filename = "phone_numbers.csv";

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },

    goToUrl(path) {
      this.$router.push(path);
    },
    goToEditPage(recordId) {
      this.$router.push(`/leads-organization/${recordId}/initial-info`);
    },
    async getEmployees() {
      const endpoint = `/employees`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.employees = response.data.contents.map((employee) => {
          return {
            id: employee.id,
            name: employee?.user?.name,
          };
        });
      } catch (error) {
        //
      }
    },
    async getLeadStages() {
      const endpoint = `/lead-stages`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.currentStage = this.currentLeadStage;
        this.leadStages = response.data.contents.map((stage) => {
          return {
            lead_stage: stage.lead_stage,
          };
        });
      } catch (error) {}
    },
    async getIndustryTypes() {
      try {
        const response = await http.get("industries");
        this.industryTypesArr = response.data.contents.map((industry) => ({
          id: industry.id,
          name: industry.type,
        }));
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async getExhibitions() {
      const endpoint = "/exhibitions";
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.exhibitions = response.data?.contents.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        //
      }
    },
    async checkLeadsPermission() {
      console.log("call again check permission");
      if (!this.userInfo || !this.userInfo.employee) {
        console.error("User info or employee data is not available.");
        return;
      }
      const endpoint = "/check-edit-permission";
      const method = "post";
      let body = {
        employeeId: this.userInfo.employee.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.permissions = response.data.permissions || [];
      } catch (error) {
        console.error("Error checking permissions:", error);
      }
    },

    hasEditPermission(leadId) {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];

      if (permissions.includes("Leads Edit")) {
        return true;
      } else {
        return (
          this.permissions.find(
            (permission) =>
              permission.lead_id == leadId &&
              permission.status == "approved" &&
              permission.permission_type == "Edit"
          ) !== undefined
        );
      }
    },
    hasDetailsPermission() {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];

      if (permissions.includes("Leads Details")) {
        return true;
      }
      return false;
    },
    isPending(leadId) {
      const permission = this.permissions.find(
        (permission) =>
          permission.lead_id == leadId &&
          permission.permission_type === "Edit" &&
          permission.status == "pending"
      );
      return permission?.status === "pending";
    },
    isDetailsPending(leadId) {
      const permission = this.permissions.find(
        (permission) =>
          permission.lead_id == leadId &&
          permission.status == "pending" &&
          permission.permission_type === "Details"
      );
      return permission?.status === "pending";
    },
    handleDetailsClick(record) {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];
      if (permissions.includes("Leads Details")) {
        this.goToDetailsPage(record.id);
      } else if (record.is_disabled == 1) {
        this.confirmDetailsRequest(record.id);
      } else {
        this.goToDetailsPage(record.id);
      }
    },
    goToDetailsPage(recordId) {
      this.$router.push(`/key-account/${recordId}/key-account-details`);
    },
    confirmEditRequest(recordId) {
      Swal.fire({
        title: "Are you sure?",
        text: "Would you like to request permission to edit this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, request it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.editRequest(recordId);
        }
      });
    },
    async editRequest(recordId) {
      this.loading = true;
      const endpoint = "/request-for-leads-edit";
      const method = "post";
      let body = {
        lead_id: recordId,
        employee_id: this.userInfo.employee.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.$toast.success(response.data.message);
        this.loading = false;
        const existingPermission = this.permissions.find(
          (permission) => permission.lead_id == recordId
        );
        if (existingPermission) {
          existingPermission.status = "pending";
        } else {
          this.permissions.push({ lead_id: recordId, status: "pending" });
        }
        this.checkLeadsPermission();
        this.refresh();
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.response.data.message);
      } finally {
        //
      }
    },
    confirmDetailsRequest(recordId) {
      Swal.fire({
        title: "Are you sure?",
        text: "Would you like to request access to the details page for this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, request it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.detailsRequest(recordId);
        }
      });
    },
    async detailsRequest(recordId) {
      this.loading = true;
      const endpoint = "/request-for-leads-details";
      const method = "post";
      let body = {
        lead_id: recordId,
        employee_id: this.userInfo.employee.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.$toast.success(response.data.message);
        this.loading = false;
        const existingPermission = this.permissions.find(
          (permission) => permission.lead_id == recordId
        );
        if (existingPermission) {
          existingPermission.status = "pending";
        } else {
          this.permissions.push({ lead_id: recordId, status: "pending" });
        }

        this.checkLeadsPermission();
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.response.data.message);
      } finally {
        //
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    openDeleteModal(row = "") {
      this.isShowModal = true;
      setTimeout(() => {
        this.$emitter.emit("delete-item-modal", row);
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  font-size: 20px;
  font-weight: bold;
}
.disabled {
  pointer-events: none;
  color: #6c757d;
  cursor: not-allowed;
}

.custom-text-truncation {
  list-style-type: none; /* Remove default list styles */
  margin: 0;
  padding: 0;
  width: 100%; /* Ensure the list takes up the full width */
}

.custom-text-truncation li {
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Use ellipsis for overflowing text */
  white-space: nowrap; /* Prevent the text from wrapping to the next line */
  display: block; /* Ensure list items are block-level */
  width: 100%; /* Ensure list items are responsive */
  max-width: 100%; /* Prevent content from spilling outside */
}

.custom-text-truncation li span {
  display: inline-block; /* Make sure the span behaves like inline-block */
  max-width: 200px; /* Set a max width to ensure truncation (adjust as needed) */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form-sort i {
  z-index: unset !important;
}
.dropdown a {
  border: unset !important;
  border-radius: unset !important;
}
</style>
